export const SET_MATCH_TYPE = "one-state-patient-match-type/set";
export const SET_MATCH_FROM = "one-state-patient-match-from/set";
export const REINIT = "one-state-patient-match-type/reset";

export enum PatientMatchType {
    SINGLE_MATCH = 'Single Match',
    MULTI_MATCH = 'Multiple Matches',
    NO_MATCH = 'No Match',
    MIS_MATCH = 'Mis Match',
    GLOBAL_MATCH = 'Global Search Match'
};

export enum PatientMatchFrom {
    GLOBAL_SEARCH = 'Global Search',
    IDENTIFY_FLOW = 'Identify Flow'
};

export interface PatientMatch {
    matchType: PatientMatchType;
    matchFrom: PatientMatchFrom;
};